import React from 'react';

import { useSendbirdStateContext } from '@sendbird/uikit-react';
import { debounce } from 'lodash-es';
import { useSetRecoilState } from 'recoil';

import { aclosetChatState } from '../AclosetChatState';

export const useRefreshTotalUnreadChannelCount = () => {
  const store = useSendbirdStateContext();

  const setter = useSetRecoilState(aclosetChatState);

  const sdk = store?.stores?.sdkStore?.sdk;

  return React.useMemo(() => {
    if (sdk != null && 'groupChannel' in sdk) {
      return debounce(
        () => {
          sdk.groupChannel.getTotalUnreadChannelCount().then((v: number) => {
            setter(prev => ({
              ...prev,
              totalUnreadChannelCount: v,
            }));
          });
        },
        5000,
        { leading: true, trailing: false },
      );
    } else {
      return undefined;
    }
  }, [sdk, setter]);
};
